<template>
  <svg
    :width="width"
    :height="height"
    :class="className"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title v-if="title">{{ title }}</title>
    <use :xlink:href="iconPath" xmlns:xlink="http://www.w3.org/1999/xlink" />
  </svg>
</template>

<script>
export default {
  name: 'svg-icon',

  props: {
    name: {
      type: String,
      required: true,
    },

    title: {
      type: String,
      default: null,
    },

    width: {
      type: String,
      default: '16',
    },

    height: {
      type: String,
      default: '16',
    },
  },

  computed: {
    iconPath() {
      let icon = require(`@/assets/svg/${this.name}.svg`)
      if (Object.prototype.hasOwnProperty.call(icon, 'default')) {
        icon = icon.default
      }

      return icon.url
    },

    className() {
      return 'svg-icon svg-icon--' + this.name
    },
  },
}
</script>

<style>
.svg-icon {
  fill: currentColor;
}
</style>
